import React from 'react'
import styles from './InitialPage.module.scss'
import { motion } from "framer-motion"

const titleAnimation = {
    hidden: {
        x: -800,
        opacity: 0,
    },

    visible: {
        x: 0,
        opacity: 1,
        transition: {ease: "easeOut", duration: 1 }
    }
}

const subtitleAnimation = {
    hidden: {
        x: 800,
        opacity: 0,
    },

    visible: {
        x: 0,
        opacity: 1,
        transition: {ease: "easeOut", duration: 1 }
    }
}


export const InitialPage = ({isOpen}) => {
    return (
        <motion.section 
        className={styles.main} 
        id='initial'
        initial='hidden'
        whileInView='visible'
        viewport={{once: true}} 
        >
            <div className={styles.overlay}></div>
                <div className={styles.container}>
                    <motion.h1 className={styles.title} variants={titleAnimation}>Проектирование, монтаж и обслуживание инженерных систем</motion.h1>
                    <div className={styles.line}></div>
                    <motion.p className={styles.text} variants={subtitleAnimation}>Мы будем держать вас в зоне комфорта.</motion.p>
                    <button className={styles.button} type='button' onClick={isOpen}>вызвать инженера</button>
                </div>
        </motion.section>
    )
}